/* Favoritos KAZUMI PMU — localStorage, sin apps externas */
(function () {
  var KEY = 'kazumi_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
    paint();
  });

  document.addEventListener('wishlist:change', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();

  /* Página de favoritos */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (grid) {
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    if (!list.length) {
      if (empty) empty.style.display = '';
      return;
    }
    Promise.all(list.map(function (handle) {
      return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (p) {
        var img = (p.featured_image || '').replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2');
        var price = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
        var compare = p.compare_at_price && p.compare_at_price > p.price
          ? '<span class="wlp-compare">' + (p.compare_at_price / 100).toFixed(2).replace('.', ',') + ' €</span>' : '';
        var cell = document.createElement('div');
        cell.className = 'wlp-cell';
        cell.innerHTML =
          '<a href="' + p.url + '" class="wlp-link">' +
          '  <div class="wlp-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
          '  <p class="wlp-title">' + p.title + '</p>' +
          '  <p class="wlp-price">' + price + ' ' + compare + '</p>' +
          '</a>' +
          '<button type="button" class="wlp-remove" data-wishlist-toggle data-handle="' + p.handle + '">Quitar</button>';
        grid.appendChild(cell);
      });
      paint();
      document.addEventListener('wishlist:change', function () {
        var l = read();
        grid.querySelectorAll('.wlp-cell').forEach(function (cell) {
          var h = cell.querySelector('[data-handle]').getAttribute('data-handle');
          if (l.indexOf(h) === -1) cell.remove();
        });
        if (!read().length && empty) empty.style.display = '';
      });
    });
  }
})();
